import React from "react";
import { StaticMenus } from "../../../context/Menus";

interface StaticMenuProps {
  activeMenu: any;
  handleMenuItemClick: any;
  open: boolean;
}

const StaticMenu: React.FC<StaticMenuProps> = ({
  activeMenu,
  handleMenuItemClick,
  open,
}) => {
  return (
    <>
      <hr className="mx-4" />
      {StaticMenus.map((Menu, index) => (
        <div key={index} className="mt-4">
          <li
            key={index}
            className={`flex mx-3 whitespace-nowrap rounded-md p-2 mb-4 px-3 cursor-pointer text-Body-OneLine/16/Bold items-center gap-x-4 
            ${
              Menu.title === "خروج از حساب" ||
              Menu.title === "بازگشت به پنل ادمین"
                ? "hover:text-red-700 text-red-700 hover:bg-gray-100"
                : "hover:bg-primary-200 hover:text-gray-900"
            }
            ${!Menu?.disable ? "text-gray-900" : "text-gray-200"} ${
              activeMenu === Menu.src
                ? "text-gray-900 font-[900] bg-gray-100 rounded-lg"
                : ""
            }`}
            onClick={() => {
              handleMenuItemClick(Menu);
            }}
          >
            {Menu.icon}
            <span className={`${open ? "" : "hidden"} flex-1`}>
              {Menu.title}
            </span>
          </li>
        </div>
      ))}
    </>
  );
};

export default StaticMenu;
